<template>
  <div class="chartElem">
    <div class="row">
      <highcharts class="chart" height="1500" :options="chartOptions" :updateArgs="updateArgs"></highcharts>
    </div>
  </div>
</template>

<script>
export default {
    name: "MultipleN",
    data: () => ({
      cursos: [
            'Materno',
            'Niño',
            'Adolescente',
            'Joven',
            'Adulto',
            'Adulto Mayor', 
        ],
        titulos: [
            'Cuidado Integral de la Gestante',
            'Cuidado Integral del Niño',
            'Cuidado Integral del Adolescente',
            'Cuidado Integral del Joven',
            'Cuidado Integral del Adulto',
            'Cuidado Integral del Adulto Mayor', 
        ],
        grupos: [
            'NEONATO',
            'MENOR DE 1 AÑO',
            '1 AÑO',
            '2 AÑOS',
            '3 AÑOS',
            '4 AÑOS',
            'DE 5 a 11 AÑOS',
        ],
      title: {
        style: {
            wordWrap: 'break-word',
            'text-align': 'center'
          }
      },
      points: [10, 0, 8, 2, 6, 4, 5, 5],
      chartType: 'Spline',
      seriesColor: '#6fcd98',
      colorInputIsSupported: null,
      animationDuration: 1000,
      updateArgs: [true, true, {duration: 1000}],
      chartOptions: {
        chart: {
            type: 'line'
        },
        title: {
          text: 'Avance Mensual',
          style: {
            wordWrap: 'break-word',
            'text-align': 'center'
          }
        },
        pane: {
            size: '100%'
        },

        xAxis: {
            categories: [],
            tickmarkPlacement: 'on',
            lineWidth: 0
        },

        yAxis: {
            gridLineInterpolation: 'polygon',
            lineWidth: 0,
            min: 0,
            title: {
            text: 'Avance (%)'
            }
        },

        plotOptions: {
            area: {
                dataLabels: {
                    enabled: true,
                    color: 'black'
                },
            }
        },

        tooltip: {
            headerFormat: '<b>{series.name}</b><br/>',
            pointFormat: '{point.category}: {point.y}%'
        },

        legend: {
        },

        series: [{
            name: '% de Avance Mensual',
            data: [],
            color: '#33C1FF',
            pointPlacement: 'on',
            type: 'line',
            dataLabels: {
                enabled: true,
                format: '{point.y} %',
                style: {
                  fontSize: '10px',
                  borderColor: "red",
                }
            },
        }],

        exporting: {
            buttons: {
                contextButton: {
                    menuItems: ['viewFullscreen', 'downloadPNG', 'downloadJPEG', 'downloadPDF']
                }
            }
        },

        responsive: {
            rules: [{
                condition: {
                    maxWidth: 400,
                },
                chartOptions: {
                    legend: {
                        align: 'center',
                        verticalAlign: 'bottom',
                        layout: 'horizontal'
                    },
                    pane: {
                        size: '80%'
                    }
                }
            }]
        }
      },
  }),
  created () {
    this.getIniciar()
  },
  props: ['serie','numerador','avance','titulo'],
  watch: {
    title (newValue) {
      this.chartOptions.title.text = newValue
    },
    points (newValue) {
      this.chartOptions.series[0].data = newValue
    },
    chartType (newValue) {
      this.chartOptions.chart.type = newValue.toLowerCase()
    },
    seriesColor (newValue) {
      this.chartOptions.series[0].color = newValue.toLowerCase()
    },
    animationDuration (newValue) {
      this.updateArgs[2].duration = Number(newValue)
    }
  },
  methods: {
    getIniciar() {
      this.chartOptions.title.text = this.titulo+' (% Avance Mensual)'
      this.chartOptions.chart.width = (window.innerWidth/12*4) *0.9
      this.chartOptions.xAxis.categories = this.serie
      this.chartOptions.series[0].data = this.avance
    },
  }
}
</script>
